module.exports = __webpack_public_path__ + "img/category__5.53846c1a.svg";